import { ImageUrlBuilder, ImageFitModeEnum } from 'kentico-cloud-delivery/_commonjs/lib';

export const slashesToDashes = text => text.replace(/\/+/g, '_');
export const underscoresToDashes = text => text.replace(/_+/g, '-');
export const dashesToUnderscores = text => text.replace(/-+/g, '_');

export const tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
};

export const replaceTag = tag => tagsToReplace[tag] || tag;

export const safeTagsReplace = str => str.replace(/[&<>]/g, replaceTag);

export const safeHtmlWithBr = (text) => {
  if (text) {
    const escapedHTML = safeTagsReplace(text);
    return escapedHTML.replace(/(&lt;br&gt;|&lt;\/br&gt;)/g, '<br>');
  }
  return '';
};

export const NBSPAfterSingleLetters = (text) => (
  text.replace(/( [A-Za-z]) /g, '$1&#xA0;')
);

export const isVideo = (fileName) => {
  const ext = (fileName.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
  return !!ext.match(/3gp|avi|mov|mp4|m4v|m4a|mp3|mkv|ogv|ogm|ogg|oga|webm|wav/);
};

export const getNumbers = (str) => {
  if (typeof str === 'string') {
    return str.replace(/\D/g, '');
  }
  return str;
};

export const croppedImageUrl = (url, width, height, quality = null) => {
  const imageUrlBuilder = new ImageUrlBuilder(url);
  if (width || height || quality) {
    imageUrlBuilder.withDpr(2).withFitMode(ImageFitModeEnum.Crop);
    if (width) {
      imageUrlBuilder.withWidth(getNumbers(width));
    }
    if (height) {
      imageUrlBuilder.withHeight(getNumbers(height));
    }
    if (quality) {
      imageUrlBuilder.withQuality(quality);
    }
  }
  return imageUrlBuilder.getUrl();
};

export const removeTags = text => (text ? text.replace(/(<([^>]+)>)/ig, '') : text);



// WEBPACK FOOTER //
// ./src/common/methods/string.js